import { createSelector } from 'reselect'

export const getAdditionalDependenciesVisibility = createSelector(
  (state) => state && state.categories && state.categories.additionalDependenciesVisibility
    ? state.categories.additionalDependenciesVisibility : {},
  (additionalDependenciesVisibility) => additionalDependenciesVisibility
)
